<ecoupon-shared-ui-lip-ecoupon-otp
  [refOTP]="refOTP()"
  [errMsg]="errMsg()"
  (emitOtp)="emitOtp($event)"
  (emitSendOTPAgain)="emitSendOTPAgain($event)"
></ecoupon-shared-ui-lip-ecoupon-otp>
<!-- {{dataFormSignal() | json }} -->
